
// FontAwesome 5 - https://fontawesome.com/
import "@fortawesome/fontawesome-pro/css/all.css";
import 'lightgallery/src/sass/lightgallery.scss';

import 'bootstrap';
import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

import AOS from 'aos';

import inlineSVG from './utilities/convert-svg-to-html';

import {gsap} from "gsap";
import sidebarNav from "./header/sidebar";

$(function () {

    sidebarNav();

    AOS.init({
        once: true,
        disable: function() {
            var maxWidth = 768;
            return window.innerWidth < maxWidth;
        }
    });

    inlineSVG('.navbar-logo, .footer-logo, .admin-logo');

    $(".down-arrow").click(function() {
        $('html, body').animate({
            scrollTop: $("#homeContent").offset().top
        }, 500);
    });


    var swiper = new Swiper(".carousel", {
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        effect: 'fade',
        speed: 1000,
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        },
    });

    var servicesSwiper = new Swiper(".services-slider", {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        breakpoints: {
            1199: {
                slidesPerView: 3,
                spaceBetween: 30
            },
            991: {
                slidesPerView: 3,
                spaceBetween: 30
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 30
            },
            576: {
                slidesPerView: 1,
                spaceBetween: 30
            }
        },
        navigation: {
            nextEl: '.next-service',
            prevEl: '.prev-service'
        },
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
    });


    var sponsorsSwiper = new Swiper(".sponsors-wrapper", {
        loop: true,
        autoplay: {
            delay: 5000
        }
    });

    //homepage load in
    const hrLine = document.querySelector(".hr-line");
    const textContent = document.querySelector('.slide-content p');
    const word = document.querySelector('.slide-content h1');
    const wordDot = document.querySelector('.slide-content h1 span');
    let tl = gsap.timeline();
    tl.to(hrLine, {
        width: '100%',
        duration: 1.5,
        delay: 0.3,
        ease: "expo.inOut"
    }).to(word, {
        y: 0,
        opacity:1,
        duration: 0.5
    }, "-=1").to(textContent, {
        y: 0,
        opacity: 1,
        duration: 0.5,
        ease: "sine"
    }, "-=1").to(wordDot, {
        opacity: 1,
        duration: 0.3,
        ease: "sine"
    });

    //page title
    const headerLine = document.querySelector(".header-line");
    const headerTitle = document.querySelector(".header-container h1");
    let headerTL = gsap.timeline();
    headerTL.to(headerLine, {
        duration: 0.5,
        opacity: 1,
        ease: "expo.inOut"
    }).to(headerTitle, {
        y: 0,
        opacity:1,
        delay: 0.3,
        duration: 0.5
    }, "-=1");
});
